import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/Logo.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "layout-login__logo",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_2 = { class: "layout-login__wrap-input" }
const _hoisted_3 = { class: "layout-login__input-addons" }
const _hoisted_4 = { class: "layout-login__input-addons" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import {
  ITirPmUserLoginRequest,
  ITirUserResponse,
} from "@/tir-pm-authenticator/src/interfaces";
import { TirPmAutentificatiorService } from "@/tir-pm-authenticator";
import { useRouter } from "vue-router";
import AuthLayout from "@/layouts/AuthLayout.vue";
import {
  UserIcon,
  KeyIcon,
  EyeIcon,
  EyeSlashIcon,
} from "tir-style-system/icons/outline";
import { TirPmInput } from "tir-pm-input";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
} from "tir-pm-button";
import { TirDivider } from "tir-pm-divider";

import { computed, onBeforeMount, onMounted, ref } from "vue";
import { TirPmPlate } from "tir-pm-plate";
import { TirPmStatusBudge } from "tir-pm-status-budge";
import TypeRoles from "@/shared/api/Main/dataSource/api/users/implementation/TypeRoles";
import ApiService from "@/shared/api";
import { CurrentUser, CurrentUserModel, UserRoleEnum } from "tir-pm-user-core";

export default /*#__PURE__*/_defineComponent({
  __name: 'LoginPage',
  setup(__props, { expose: __expose }) {

const api = new ApiService();
const router = useRouter();

/**
 *  Переменные для инпутов
 */
const login = ref("");
const password = ref("");

/**
 *  Переменные для показа инпутов и ошибки
 */
const showPassword = ref(false);
const showPlateWarning = ref(false);

const typePassword = computed(() => {
  return showPassword.value ? "text" : "password";
});

/**
 * Блок элемента контента
 */
const $currentComponentWrapper = ref(null);

/**
 * Текущая высота элемента контента
 */
const currentHeightComponent = ref(null);

/**
 * Перерасчет высоты
 */
const currentHeightLocalComputed = computed(() => {
  return currentHeightComponent.value;
});


/**
 * Лоадер для кнопки
 */
 const loadingRequest = ref(false)

/**
 * Перерасчет высоты
 */
 const loadingRequestComputed = computed(() => {
  return loadingRequest.value;
});

const mapRole = (role: TypeRoles) => {
    return {
      [TypeRoles.Employee]: UserRoleEnum.Employee,
      [TypeRoles.Owner]: UserRoleEnum.Owner,
      [TypeRoles.NamespaceAdmin]: UserRoleEnum.NamespaceAdmin,
      [TypeRoles.ProjectAdmin]: UserRoleEnum.ProjectAdmin,
    }[role];
  }

/**
 *  Метод для автооризации
 */
const onLogin = async () => {
  loadingRequest.value = true
  try {
    let data = await api.Main.UsersService.loginAsync({
      Email: login.value,
      Password: password.value,
    });
    const userResp = await api.Main.UsersService.getCurrentUserAsync();
    CurrentUser.set(new CurrentUserModel({
      Id: userResp.Id,
      Email: userResp.Email,
      FirstName: userResp.FirstName,
      LastName: userResp.LastName,
      MiddleName: userResp.MiddleName,
      AvatarColor: userResp.AvatarColor,
      Foto: userResp.Foto,
      Roles: userResp.Roles.map(mapRole),
    }))
    showPlateWarning.value = false;
    router.push("/projects");
  } catch (error) {
    console.error(error);
    showPlateWarning.value = true;
    loadingRequest.value = false
  }
  setTimeout(() => {
    currentHeightComponent.value = $currentComponentWrapper.value?.offsetHeight;
  });
};

onMounted(() => {
  currentHeightComponent.value = $currentComponentWrapper.value?.offsetHeight;
});

__expose({
  changerMethodFromComponent: onLogin,
  currentHeightComponent: currentHeightLocalComputed,
  isLoadingIntoComponent: loadingRequestComputed
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: "layout-login__body",
    ref_key: "$currentComponentWrapper",
    ref: $currentComponentWrapper
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(TirPmInput), {
        type: "email",
        test: "email",
        modelValue: login.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((login).value = $event)),
        isAutocomplete: "",
        label: "Электронная почта",
        placeholder: "",
        isWithError: showPlateWarning.value,
        isWithHint: false
      }, {
        leftInputAddons: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_unref(UserIcon))
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "isWithError"]),
      _createVNode(_unref(TirPmInput), {
        isAutocomplete: "",
        label: "Пароль",
        test: "password",
        type: typePassword.value,
        modelValue: password.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((password).value = $event)),
        placeholder: "",
        isWithHint: false,
        isWithError: showPlateWarning.value
      }, {
        leftInputAddons: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_unref(KeyIcon))
          ])
        ]),
        hintMessage: _withCtx(() => []),
        rightInputAddons: _withCtx(() => [
          _createElementVNode("div", {
            class: _normalizeClass(["layout-login__input-addons layout-login__input-addons--action", {
              'layout-login__input-addons--show': password.value.length,
            }])
          }, [
            (!showPassword.value)
              ? (_openBlock(), _createBlock(_unref(EyeIcon), {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showPassword.value = !showPassword.value))
                }))
              : _createCommentVNode("", true),
            (showPassword.value)
              ? (_openBlock(), _createBlock(_unref(EyeSlashIcon), {
                  key: 1,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showPassword.value = !showPassword.value))
                }))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _: 1
      }, 8, ["type", "modelValue", "isWithError"]),
      _createVNode(_unref(TirPmPlate), {
        isShow: showPlateWarning.value,
        variant: "negative",
        isRounded: "",
        test: "error-login-msg"
      }, {
        leftAddon: _withCtx(() => [
          _createVNode(_unref(TirPmStatusBudge), {
            "status-color": "negative",
            "status-icon-type": "alert"
          })
        ]),
        text: _withCtx(() => [
          _createTextVNode(" Ошибка авторизации – неверное введение логина, пароля. "),
          _hoisted_5,
          _createVNode(_component_RouterLink, {
            to: "/restore-access",
            class: "layout-login__linkto-other"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Восстановить доступ")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["isShow"])
    ])
  ], 512))
}
}

})